module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result13-d31a207107bfb3204c5efa25258605e5.png";